module.exports = __webpack_public_path__ + "static/media/bg10.00c2c645.jpg";